import type { IconName } from './paths'
import { ICON_PATHS } from './paths'

interface IconProps {
  name: IconName
  /** Rendered size in pixels; defaults to the surrounding font size. */
  size?: number | string
  className?: string
}

/**
 * Renders a single glyph. Inherits `currentColor` so colour is always the
 * caller's decision, and is hidden from assistive technology — icons here are
 * decorative, with their meaning carried by adjacent text or an aria-label.
 */
export const Icon = ({ name, size = '1em', className }: IconProps) => (
  <svg
    viewBox="0 0 256 256"
    width={size}
    height={size}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d={ICON_PATHS[name]} />
  </svg>
)
